import { createSelector } from '@ngrx/store';

import * as fromLookup from '../reducers/lookup.reducers'
import * as fromRoot from '../reducers'

export const selectLicenseTypes = createSelector(fromRoot.selectLookupState, fromLookup.getLicenseTypes);
export const selectContactTypes = createSelector(fromRoot.selectLookupState, fromLookup.getContactTypes);
export const selectCountries = createSelector(fromRoot.selectLookupState, fromLookup.getCountries);
export const selectIdTypes = createSelector(fromRoot.selectLookupState, fromLookup.getIdTypes);
export const selectVenueTypes = createSelector(fromRoot.selectLookupState, fromLookup.getVenueTypes);
export const selectAccessCardTypes = createSelector(fromRoot.selectLookupState, fromLookup.getAccessCardTypes);
export const selectRequestAccessCardReasons = createSelector(fromRoot.selectLookupState, fromLookup.getRequestAccessCardReasonsSuccess);
export const selectChargeTypes = createSelector(fromRoot.selectLookupState, fromLookup.getChargeTypes);
export const selectUsers = createSelector(fromRoot.selectLookupState, fromLookup.getUsers);
export const selectAccessCardCancellationReasons = createSelector(fromRoot.selectLookupState, fromLookup.getAccessCardCancellationReasons);
export const selectRequestStatuses = createSelector(fromRoot.selectLookupState, fromLookup.getRequestStatuses);



// WEBPACK FOOTER //
// ./src/app/core/store/selectors/lookup.selectors.ts